<h1 style="text-align: center;">ReAdPQC24 - Recent Advances in Post-Quantum Cryptography 2024</h1>
<h2>Organizers</h2>
<p>
    <b></b>
    <em>
        Giulio Codogni (Tor Vergata University, Italy)
        <br>
        Roberto La Scala (University of Bari, Italy)
        <br>
        Edoardo Persichetti (Florida Atlantic University, USA)
        <br>
        Federico Pintore (University of Trento, Italy)
    </em>
</p>
<h2>Description</h2>
<p>
    Post-quantum cryptography, that is, the study of cryptographic schemes capable of withstanding attackers equipped
    with both classical and quantum computers, is an area of research that has experienced tremendous growth in recent
    years, also due to the initiation of a standardization effort by NIST, which has led to the selection of the first
    schemes to standardise. More recently, the focus has been on post-quantum digital signature schemes, which are the
    subject of the latest NIST competition. This workshop will provide an overview of the state of the art in
    post-quantum cryptography, along with the NIST competition, and focus on cutting-edge methods for designing and
    implementing post-quantum signatures.
</p>
<h2>Acknowledgements</h2>
<p>
        This workshop was partially financially supported by the Italian MUR PRIN 2022 project POst quantum
        Identification and eNcryption primiTives: dEsign and Realization (POINTER) ID-2022M2JLF2.
</p>
<h2>Program</h2>
<p>
    <i> September 27th, workshop session</i>
    <br>
    <i>Main hall, 14:00 - 16:30</i>
</p>
<p>
    Keynote speaker: <b>Thibauld Feneuil</b>, CryptoExperts (France)
</p>
<table class="orari" cellspacing="2" cellpadding="2" id="27afternoon">
    <tr bgcolor="lightblue">
        <th class="schedule" colspan="2">
            <font size="+1"><b>September 27th (afternoon) - Workshop Session</b></font>
        </th>
    </tr>
    <tr>
        <td class="schedule">
            14:00
            14:40
        </td>
        <td>
            <i>
                <b>Thibauld Feneuil</b>, CryptoExperts (France)
            </i>
            <br>
            Post-Quantum Signatures from Secure Multiparty Computation
            (<a target="_blank" href="https://drive.google.com/file/d/1g52LG6w84VxGKQSIqOZF08BL_7_ZSZGC">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                The MPC-in-the-Head (MPCitH) paradigm is a versatile framework to design zero-knowledge proofs and
                post-quantum signatures, by relying on secure multi-party computation (MPC) techniques. It has recently
                been improved in a series of works which makes it a practical and tunable tool. This paradigm has been
                utilized in 9 out of the 40 candidates selected for the first round of the recent NIST call for
                additional post-quantum signatures. In this talk, I will provide a general introduction to MPCitH,
                discuss the latest MPCitH techniques, and show how they can be used to build efficient post-quantum
                signatures.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            14:40
            15:05
        </td>
        <td>
            <i>
                <b>Rocco Mora</b>, CISPA Helmholtz Center for Information Security (Germany)
            </i>
            <br>
            The Regular Multivariate Quadratic problem
            <details>
                <summary>
                    Abstract
                </summary>
                In this talk, we introduce a new NP-complete variant of the multivariate quadratic problem. The
                computational challenge involves finding a solution to an algebraic system that meets the "regular"
                constraint, meaning that each block of the solution vector contains only one nonzero entry. Following
                this, we adapt and compare various techniques of cryptanalysis to study the asymptotic complexity of the
                average instance.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            15:05
            15:15
        </td>
        <td>
            <i>
                Coffee Break
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            15:15
            15:40
        </td>
        <td>
            <i>
                <b>Ryann Cartor</b>, Clemson University (USA)
            </i>
            <br>
            MinRank Attacks in Multivariate Cryptography
            (<a target="_blank" href="https://drive.google.com/file/d/1GiI2wquBCjnQmGy4Byq-O9HVi2gY1c8K">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                This talk focuses on the cryptanalysis of post-quantum cryptography schemes, particularly focusing on
                multivariate and rank-metric code-based cryptosystems. As quantum computing advances, these schemes have
                gained attention for their unique performance characteristics, but they are vulnerable to MinRank
                attacks, which have exposed critical security flaws. The MinRank problem, central to these attacks, has
                been effectively used to break several prominent cryptosystems. This presentation will examine two
                distinct MinRank-based attacks on the multivariate encryption scheme HFERP, offering new insights into
                cryptanalytic techniques and their implications for the future of post-quantum cryptography. The
                discussion highlights the necessity of continuous cryptanalysis and innovation in developing
                quantum-resistant cryptosystems.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            15:40
            16:05
        </td>
        <td>
            <i>
                <b>Luciano Maino</b>, University of Bristol (UK)
            </i>
            <br>
            Attack-based encryption using isogenies
            (<a target="_blank" href="https://drive.google.com/file/d/1Ah69h9nxoXCaYh7d421NOj68obCOMMAQ">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                In this talk, we will describe how to turn an attack into a constructive tool. In particular, we will
                introduce FESTA, a public-key encryption mechanism derived from an attack on a specific isogeny problem.
                The practicality of FESTA relies on novel efficient algorithms to compute isogenies between abelian
                surfaces. We will give some intuition on such algorithms and finally discuss recent developments in
                isogeny-based cryptography.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            16:05
            16:30
        </td>
        <td>
            <i>
                <b>Andrea Basso</b>, IBM Zurich (Switzerland)
            </i>
            <br>
            SQIsign2D-West: The Fast, the Small, and the Safer
            (<a target="_blank" href="https://drive.google.com/file/d/1jU7hZDGaLuJ0QSsNSNSJVdheQEhduPD0">slides</a>)
            <details>
                <summary>
                    Abstract
                </summary>
                SQIsign is the leading isogeny-based signature scheme: it is the only isogeny-based candidate in the
                NIST, and it offers small signatures, at the cost of long computation times.
                In this talk, we briefly survey the developments of SQIsign over the years, and we introduce
                SQIsign2D-West, a variant of SQIsign using two-dimensional isogeny representations. The new signature
                scheme offers remarkable performance (80 ms for signing, 4.5 ms for verification), compact signatures
                (66 bytes for a public key, 148 bytes for a signature), and strong security (by relying on a simple
                assumption). This represents an improvement over one-dimensional SQIsign in all metrics and better
                trade-offs than all SQIsign variants.
            </details>
        </td>
    </tr>
</table>